<template>
  <div>
    <!-- pc端 -->
    <nav
      :class="['header',{'header-scrolled': scrollShow}]"
      @mouseover="navMouseover"
      @mouseout="navMouseout"
    >
      <div class="nav-box">
        <div class="nav-left">
          <!-- logo -->
          <div class="logo-box">
            <router-link to="/">
              <img class="img-logo" :src="logoImg">
            </router-link>
          </div>
          <!-- 路由导航 -->
          <div class="nav-list">
            <el-menu
              v-if="menuShow"
              :default-active="pathUrl"
              :router="true"
              class="el-menu-demo"
              mode="horizontal"
              background-color="rgba(0,0,0,0)"
              :text-color="menuTextColor"
              active-text-color="#3777F6"
              popper-class="nav-pup"
            >
              <el-menu-item index="/">首页</el-menu-item>
              <el-submenu
                index="/solution"
                :popper-class="popperClass"
                :popper-append-to-body="false"
                :hide-timeout="0"
              >
                <template slot="title">解决方案</template>
                <el-menu-item index="/solution/group">集团型客户</el-menu-item>
                <el-menu-item index="/solution/city">区域型客户</el-menu-item>
                <el-menu-item index="/solution/project">项目型客户</el-menu-item>
              </el-submenu>
              <el-menu-item index="/cases">成功案例</el-menu-item>
              <el-menu-item @click="goSWG">思为观</el-menu-item>
              <el-submenu
                index="/about"
                :popper-class="popperClass"
                :popper-append-to-body="false"
                :hide-timeout="0"
              >
                <template slot="title">关于我们</template>
                <el-menu-item index="/about">关于思为</el-menu-item>
                <el-menu-item @click="goJoin">加入我们</el-menu-item>
                <!-- <el-menu-item index="/partner">合作伙伴</el-menu-item> -->
              </el-submenu>
            </el-menu>
          </div>
        </div>
        <!-- 电话、立即体验 -->
        <div class="nav-right">
          <div class="phone">
            <img class="phone-img" :src="phoneImg">
            <span :style="{ color: (this.scrollShow || this.back) ? '#2D2E30':''}">400-8075-618</span>
          </div>
          <div class="go-experience" @click="goReservation">
            立即体验
          </div>
        </div>
      </div>
    </nav>
    <!-- 移动端 -->
    <nav class="min-header-box">
      <div class="min-header">
        <div class="min-logo-box">
          <img class="img-logo" src="https://cdn.ideamake.cn/sw-pc/images/header_logo_black.png">
        </div>
        <div class="min-nav-right">
          <img class="min-nav-icon min-nav-phone" @click="callPhone" src="https://cdn.ideamake.cn/sw-pc/images/min-phone/min_phone.png">
          <img class="min-nav-icon min-nav-list" @click="showPopup" src="https://cdn.ideamake.cn/sw-pc/images/min-phone/min_list.png">
        </div>
      </div>
      <!-- 下拉导航栏 -->
      <van-popup v-model="minNavShow" position="top">
        <div class="min-nav-popup">
          <ul class="navpopup-list">
            <li
              :class="['popup-list-item',{'active': pathUrl === '/'}]"
              @click="goRoute('/')"
            >
              首页
            </li>
            <li
              :class="['popup-list-item','popup',{'popup-show': itemPopupShow},{'active': pathUrl.indexOf('/solution') !== -1}]"
              @click="showItemPopup"
            >
              解决方案
            </li>
            <div class="item-popup" v-show="itemPopupShow">
              <li
                :class="['popup-list-item',{'active': pathUrl === '/solution/group'}]"
                @click="goRoute('/solution/group')"
              >
                集团型客户
              </li>
              <li
                :class="['popup-list-item',{'active': pathUrl === '/solution/city'}]"
                @click="goRoute('/solution/city')"
              >
                区域型客户
              </li>
              <li
                :class="['popup-list-item',{'active': pathUrl === '/solution/project'}]"
                @click="goRoute('/solution/project')"
              >
                项目型客户
              </li>
            </div>
            <li
              :class="['popup-list-item',{'active': pathUrl === '/cases'}]"
              @click="goRoute('/cases')"
            >
              成功案例
            </li>
            <!-- <li class="popup-list-item" @click="goSWG">思为观</li> -->
            <li
              :class="['popup-list-item','popup',{'popup-show': aboutPopupshow},{'active': pathUrl.indexOf('/about') !== -1 || pathUrl.indexOf('/partner') !== -1}]"
              @click="showAboutPopup"
            >
              关于我们
            </li>
            <div class="item-popup" v-show="aboutPopupshow">
              <li
                :class="['popup-list-item',{'active': pathUrl === '/about'}]"
                @click="goRoute('/about')"
              >
                关于思为
              </li>
              <li
                class="popup-list-item"
                @click="goJoin"
              >
                加入我们
              </li>
              <!-- <li
                :class="['popup-list-item',{'active': pathUrl === '/partner'}]"
                @click="goRoute('/partner')"
              >
                合作伙伴
              </li> -->
            </div>
          </ul>
          <div class="go-experience" @click="goReservation">立即体验</div>
        </div>
      </van-popup>
    </nav>
  </div>
</template>

<script>
import { jsonp } from 'vue-jsonp'
import utils from '@/utils'

export default {
  name: 'SwHeader',
  components: {
  },
  data () {
    return {
      scrollShow: false, // 页面滚动
      pathUrl: '/', // 首页
      menuShow: true,
      minNavShow: false,
      itemPopupShow: false,
      aboutPopupshow: false, // 关于我们下拉
    }
  },
  computed: {
    logoImg () {
      return (this.scrollShow || this.back) ? 'https://cdn.ideamake.cn/sw-pc/images/header_logo_black.png' : 'https://cdn.ideamake.cn/sw-pc/images/header_logo_white.png'
    },
    phoneImg () {
      return (this.scrollShow || this.back) ? 'https://cdn.ideamake.cn/sw-pc/images/phone_black.png' : 'https://cdn.ideamake.cn/sw-pc/images/phone_white.png'
    },
    menuBackgroundColor () {
      return this.scrollShow ? '#FFFFFF' : 'rgba(0,0,0,0)'
    },
    menuTextColor () {
      return (this.scrollShow || this.back) ? '#2D2E30' : '#FFFFFF'
    },
    popperClass () {
      return this.scrollShow ? 'header-nav-popup scrolled' : 'header-nav-popup'
    },
    back () {
      let data = false
      if(this.pathUrl === ('/experience')) {
        data = true
      } else if(this.pathUrl === ('/reservation')) {
        data = true
      } else if(this.pathUrl === ('/')) {
        data = true
      }
      return data
    },
  },
  watch: {
    '$route.path' () {
      this.pathUrl = utils.changeRoutePath(this.$route.path)
      // 刷新组件防止选中BUG
      if(this.pathUrl === '/experience'){
        this.menuShow = false
        setTimeout(() => {
          this.menuShow = true
        }, 1)
      } else if (this.pathUrl === '/reservation'){
        this.menuShow = false
        setTimeout(() => {
          this.menuShow = true
        }, 1)
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  created () {
    this.pathUrl = utils.changeRoutePath(this.$route.path)
    window.addEventListener('scroll', this.handleScroll)
    this.getLocation()
  },
  methods:{
    // 获取当前定位并存储【后续使用】
    getLocation(){
      var data = {key: "WDTBZ-EOPRG-5ONQY-IDVMO-NXIIK-C4B7A"};
      var url = "https://apis.map.qq.com/ws/location/v1/ip"; //这个就是地理位置信息的接口
      data.output = "jsonp";
      jsonp(url, data)
      .then(res => {
        const ipAddress = res.result.ip
        const ad_info = res.result.ad_info
        const { nation, province, city, district } = ad_info
        const addressInfo = nation + province + city + district
        sessionStorage.setItem('ip_address', ipAddress)
        sessionStorage.setItem('info_address', addressInfo)
      })
      .catch(error => {
        console.log(error)
      })
    },
    navMouseover () {
      this.scrollShow = true
    },
    navMouseout () {
      this.scrollShow = window.pageYOffset === 0 ? false : true
    },
    handleScroll() {
      this.scrollShow = window.pageYOffset > 0 ? true : false
    },
    // 跳转思为观
    goSWG() {
      window.open('https://applmkip5ay1116.pc.xiaoe-tech.com/page/2088805?navIndex=0', '_blank')
    },
    // 跳转加入我们
    goJoin() {
      window.open('https://ideamake.zhiye.com/home', '_blank')
    },
    // 跳转立即体验
    goExperience() {
      this.minNavShow = false
      this.$router.push({ path: '/experience' })
    },
    // 跳转预约演示
    goReservation() {
      this.$router.push({ path: '/reservation' })
    },

    // 移动端配置
    // 调用拨号功能
    callPhone () {
      window.location.href = 'tel://' + '400-8075-618'
    },
    showPopup () {
      this.minNavShow = !this.minNavShow
    },
    goRoute (routePath ) {
      this.minNavShow = false
      this.$router.push({ path: routePath })
    },
    showItemPopup () {
      this.itemPopupShow = !this.itemPopupShow
    },
    showAboutPopup () {
      this.aboutPopupshow = !this.aboutPopupshow
    },
  }
}
</script>

<style lang="scss" scoped>
nav.header{
  width: 100%;
  height: 62px;
  overflow: hidden;
  padding: 4px 0 0 0;
  box-sizing: border-box;
  position: fixed;
  color: #FFFFFF;
  -webkit-transition: all .3s ease-in-out;
  z-index: 500;
  &.header-scrolled{
    padding: 0;
    background: #FFFFFF;
    color: #2D2E30;
    box-shadow: 0 0 4px rgb(0 0 0 / 10%);
  }
}
.nav-box{
  max-width: 1200px;
  min-width: 900px;
  margin: 0 auto;
  height: 100%;
  display: flex;
  justify-content: space-between;
  .nav-left{
    display: flex;
    align-items: center;
    .logo-box{
      width: auto;
      height: 30px;
      display: flex;
      align-items: center;
      a{
        display: flex;
        align-items: center;
        color: #fff;
      }
      .img-logo{
        width: auto;
        height: 28px;
      }
    }
    .nav-list{
      margin-left: 50px;
      height: 62px;
      ::v-deep .el-menu{
        border: none;
        .el-menu-item{
          height: 62px;
          line-height: 62px;
          font-weight: 500;
          border-bottom-color: rgba(0,0,0,0) !important;
          &.is-active{
            border-bottom: none;
          }
          &:hover{
            background-color: rgba(0,0,0,0) !important;
            color: #3777F6 !important;
          }
        }
        .el-submenu{
          .el-submenu__title{
            height: 62px;
            line-height: 62px;
            font-weight: 500;
            border-bottom-color: rgba(0,0,0,0) !important;
            &:hover{
              background-color: rgba(0,0,0,0) !important;
              // color: #3777F6 !important;
            }
            .el-submenu__icon-arrow.el-icon-arrow-down{
              display: none;
            }
          }
          &.is-active{
            .el-submenu__title{
              border-bottom: none;
            }  
          }
        }
      }
    }
  }
  .nav-right{
    display: flex;
    align-items: center;
    .phone{
      display: flex;
      align-items: center;
      font-weight: 500;
      .phone-img{
        width: 17px;
        height: 16px;
        margin-right: 6px;
      }
    }
    .go-experience{
      cursor: pointer;
      margin-left: 32px;
      width: 88px;
      height: 32px;
      background: #3777F6;
      line-height: 32px;
      text-align: center;
      border-radius: 2px;
      font-size: 14px;
      color: #FFFFFF;
      &:hover{
        background: #5F92F8;
      }
    }
  }
}
@import "@/assets/scss/min-index";
</style>
